import { render, staticRenderFns } from "./OrganisationDetails.vue?vue&type=template&id=6ce86574&scoped=true"
import script from "./OrganisationDetails.vue?vue&type=script&lang=js"
export * from "./OrganisationDetails.vue?vue&type=script&lang=js"
import style0 from "./OrganisationDetails.vue?vue&type=style&index=0&id=6ce86574&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ce86574",
  null
  
)

export default component.exports